import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { ConfirmationServidorConfig } from "./confirmation-servidor.types";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { CommonModule, NgClass } from "@angular/common";
import { CpfCnpjValidator } from "app/shared/directives/cpfcnpj-validator/cpfcnpj.validator";

@Component({
  selector: "app-dialog-servidor",
  templateUrl: "./dialog-servidor.component.html",
  styles: [
    `
      .fuse-confirmation-dialog-panel {
        @screen md {
          @apply w-160;
        }

        .mat-dialog-container {
          padding: 0 !important;
        }
      }
    `,
  ],
  standalone: true,
  imports: [MatButtonModule, MatDialogModule, MatIconModule, NgClass, CommonModule]
})
export class DialogServidorComponent implements OnInit {
  form: FormGroup;

  constructor(
    public _fb: FormBuilder,
    public dialogRef: MatDialogRef<DialogServidorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationServidorConfig
  ) {}

  ngOnInit(): void {
    this.form = this._fb.group({
      cpf: ['', [Validators.required, CpfCnpjValidator.validate]],
      nome: ['', Validators.required],
    });
  }

  incluirServidor() {
    sessionStorage.setItem("usuario", JSON.stringify(this.form.value));
    this.dialogRef.close();
  }
}
